// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PageList-pageList-3Iaxw {\n  border-top: 1px solid #edeceb;\n  background: #faf9f7;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n", ""]);
// Exports
exports.locals = {
	"pageList": "PageList-pageList-3Iaxw"
};
module.exports = exports;
